import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const medicaid = [
  {
    path: '/vector/medicaid/applications',
    name: 'vector-medicaid-applications',
    component: () => import('@/pages/vector/medicaid/index.vue'),
    meta: { title: 'Medicaid Applications', resource: 'Vector', action: 'read', subject: 'Case' },
    beforeEnter() { redirectIfNotVector() },
  },
  {
    path: '/vector/medicaid/applications/:application_uuid',
    name: 'vector-medicaid-application-detail',
    component: () => import('@/pages/vector/medicaid/ApplicationDetail.vue'),
    meta: { title: 'Medicaid Application', resource: 'Vector', action: 'read', subject: 'Case' },
    beforeEnter() { redirectIfNotVector() },
  },
  {
    path: '/vector/medicaid/pam-assignments',
    name: 'vector-medicaid-pam-assignments',
    component: () => import('@/pages/vector/medicaid/PamAssignmentsPage.vue'),
    meta: { title: 'PAM Assignments', resource: 'Vector', action: 'read', subject: 'Case' },
    beforeEnter() { redirectIfNotVector() },
  },
]

export default medicaid
